if (!customElements.get('protection-search')) {
  /**
   * ProtectionSearch
   */
  class ProtectionSearch extends HTMLElement {
    constructor() {
      super();

      // Handle click on protection cards
      this.addEventListener('click', (event) => {
        this.target = this.target || this.querySelector('[data-protection-target]');
        if (event.target.closest('predictive-search') && event.target.closest('a')) {
          event.preventDefault();
          event.stopPropagation();
          this.handleClick(event);
        }
      });

      // Prevent form submit
      this.querySelector('form').addEventListener('submit', (event) => {
        event.preventDefault();
        event.stopPropagation();
        return false;
      });

      // On input change, clear the target
      this.input = this.querySelector('[data-predicative-search="input"]');
      this.input.addEventListener(
        'input',
        debounce((event) => {
          this.onChange(event);
        }, 100).bind(this)
      );

      this.input.addEventListener('keyup', () => {
        this.onChange();
      });
    }

    onChange() {
      this.target.innerHTML = '';
    }

    // Handle click on protection card
    handleClick(event) {
      let href = event.target.closest('[data-protection-card]').href;
      if (href.includes('?')) {
        href += '&';
      } else {
        href += '?';
      }
      href +=  'sections=protection-search-details';
      fetch(href)
        .then((response) => response.json())
        .then((data) => {
          this.target.innerHTML = data['protection-search-details'];
          window.scrollTo({ top: this.target.offsetTop - window.innerHeight / 4, behavior: 'smooth' });
        });
    }
  }

  window.ProtectionSearch = ProtectionSearch;

  customElements.define('protection-search', ProtectionSearch);
}
